export enum AuthMode {
    OTP = 'otp',
    PASSWORD = 'password',
    FORGOT_PASSWORD = 'forgot_password',
}
